import {Component, Inject} from '@angular/core';
import {MAT_DIALOG_DATA} from '@angular/material/dialog';
import {ThemeService} from "../../_services/theme.service";
import {CommunitiesService} from "../../_services/communities.service";
import {Community} from "../../_types/communities";
import {User} from "../../_types/user";
import {RewardsService} from "../../_services/rewards.service";

@Component({
    selector: 'app-levels',
    templateUrl: './levels.component.html',
    styleUrl: './levels.component.scss'
})
export class LevelsComponent {
    currentPoints: number = 0;
    level: any;
    color: string = 'var(--theme-primary-500)'

    constructor(
        protected themeService: ThemeService,
        private readonly communityService: CommunitiesService,
        private readonly rewardsService: RewardsService,
        @Inject(MAT_DIALOG_DATA) private data: { user: User, community: Community }
    ) {
        if (data.community?.id && data.user?.id) {
            this.communityService.getUserMembership(data.community.id, data.user?.id).subscribe(r => {
                if (r.data.level.is_active) {
                    this.level = r.data.level;
                    this.rewardsService.getUserPoints(data.community.id).subscribe(r => {
                        this.currentPoints = r.points || 0;
                    }, e => {
                        console.error(e);
                    })
                    this.color = this.level?.custom_color_hex || data.community?.levels_progress_slider_bg_color_hex || 'var(--theme-primary-500)'
                }
            }, e => {
                console.error(e)
            })
        }

    }

    getPercent(value: number, requiredPoints: number): number {
        return (value * 100) / (requiredPoints || 1);
    }
}
